export const DRAFT_KEY = 'guardly_apply_draft_v1';

export function loadDraft() {
  try {
    const raw = localStorage.getItem(DRAFT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && Number.isFinite(parsed.step) && parsed.values && typeof parsed.values === 'object' && !Array.isArray(parsed.values)) {
      return parsed;
    }
    return null;
  } catch (e) {
    return null;
  }
}

export function saveDraft(draft) {
  try {
    localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
  } catch (e) {}
}

export function clearDraft() {
  try {
    localStorage.removeItem(DRAFT_KEY);
  } catch (e) {}
}

export function pruneSensitive(values) {
  try {
    const clone = JSON.parse(JSON.stringify(values));
    if (clone && clone.personalInfo && clone.personalInfo.governmentId !== undefined) {
      delete clone.personalInfo.governmentId;
    }
    if (clone && clone.personalInfo && clone.personalInfo.dateOfBirth !== undefined) {
      delete clone.personalInfo.dateOfBirth;
    }
    if (clone && clone.backgroundCheck && clone.backgroundCheck.criminalRecord && clone.backgroundCheck.criminalRecord.details !== undefined) {
      delete clone.backgroundCheck.criminalRecord.details;
    }
    return clone;
  } catch (e) {
    return {};
  }
}

export function mergeDeep(base, override) {
  if (!base || typeof base !== 'object') return override;
  if (!override || typeof override !== 'object') return base;
  const result = Array.isArray(base) ? [] : {};
  for (const key of Object.keys(base)) {
    result[key] = base[key];
  }
  for (const key of Object.keys(override)) {
    if (base[key] && override[key] && typeof base[key] === 'object' && typeof override[key] === 'object' && !Array.isArray(base[key]) && !Array.isArray(override[key])) {
      result[key] = mergeDeep(base[key], override[key]);
    } else {
      result[key] = override[key];
    }
  }
  return result;
}

export function debounce(fn, waitMs) {
  let timeoutId = null;
  let lastArgs = null;
  const wrapped = (...args) => {
    lastArgs = args;
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      timeoutId = null;
      fn(...lastArgs);
    }, waitMs);
  };
  wrapped.flush = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
      fn(...lastArgs);
    }
  };
  return wrapped;
}
